import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import cx from "classnames";
import s from "./listFilter.scss";
import { t } from "i18next";
import Select, { components } from "react-select";
import DropdownIndicator from "Components/customArrowSelect/CustomArrowSelect";
import qs from "query-string";

const ListFilter = ({
  values = [],
  totals: propTotals = {},
  paginationInfo = {},
  url,
  param = "status",
  legendIcons,
  className,
  active,
  disabled,
  placeholder,
  labelPrefix,
}) => {
  const [options, setOptions] = useState(values.map((str) => ({ value: str, label: str })));
  const [totals, setTotals] = useState(propTotals);

  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    setOptions(values.map((str) => ({ value: str, label: str })));
  }, [values]);

  useEffect(() => {
    if (propTotals && Object.keys(propTotals).length > 0) {
      setTotals(propTotals);
    }
  }, [propTotals]);

  const updateValue = ({ value }) => {
    // eslint-disable-next-line no-unused-vars
    const { totals, total_pages, total_records, query, sort, sort_field, ...queryParams } = paginationInfo;

    const currentParams = qs.parse(location.search);
    const newParams = {
      ...queryParams,
      ...currentParams,
      [param]: value,
      page: 1,
      per: 25,
      ...(sort ? { sort } : {}),
      ...(sort_field ? { sort_field } : {}),
    };

    history.push({
      pathname: url,
      search: qs.stringify(newParams),
      state: { prevPathname: url },
    });
  };

  const generateLabel = (key) => {
    const baseKey = `select.status.${labelPrefix ? `${labelPrefix}.` : ""}${key}`;
    const base = t(baseKey) || key;
    return totals?.[key] != null ? `${base} [${totals[key]}]` : base;
  };

  const activeOption = options.find((o) => o.value === active) ?? options[0];

  const SingleValue = ({ children, ...props }) => (
    <components.SingleValue {...props}>
      <div className={s.optionSelected}>
        {legendIcons && <div className={s.status}>{legendIcons[children]}</div>}
        {generateLabel(children)}
      </div>
    </components.SingleValue>
  );

  const Option = (props) => (
    <div className={s.option}>
      {legendIcons && <div className={s.status}>{legendIcons[props.children]}</div>}
      <components.Option {...props}>{generateLabel(props.children)}</components.Option>
    </div>
  );

  return (
    <Select
      className={cx(className, "wrapSelect", s.listFilter, {
        [s.notIcon]: !legendIcons,
      })}
      classNamePrefix="select"
      defaultValue={options[0]}
      value={activeOption}
      onChange={updateValue}
      options={options}
      isSearchable={false}
      components={{ Option, SingleValue, DropdownIndicator }}
      isDisabled={disabled}
      placeholder={placeholder}
    />
  );
};

export default ListFilter;
